import React, { useState } from 'react'
import { Header, Modal, Button, Icon, Table, Grid } from 'semantic-ui-react'
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";

import "./AboutRealstate.css"

const AboutRealstate = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<div className="AboutRealstate m-3-t m-3-b">
        <Header as='h3'>{t("property:Description")}</Header>


        <ShowMoreText
            lines={2}
            more={t("property:More")}
            less={t("property:Less")}
            className="content-css"
            anchorClass="my-anchor-css-class ui button d-block basic w-max m-1-t blue text-blue  text-right"
            expanded={false}
            truncatedEndingComponent={""}
        >
لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.        </ShowMoreText>

    </div>
    )
}
export default AboutRealstate